<template>
  <div class="video_item">
    <div class="overlay" v-if="showPopup"></div>
    <div class="popup_window" v-if="showPopup">
      <img class="broken_cookie" src="../assets/images/broken_cookie.svg" alt="" />
      <h4>Video exceeds set time.</h4>
      <p>
        This video is longer than the time we set. You can watch it, but you
        won't see the whole thing. Do you still want to watch?
      </p>
      <button @click="navigateToPlay">Yes</button>
    </div>

    <a :href="baseUrl + 'play/' + id">
      <video controls ref="videoPlayer" @loadedmetadata="handleMetadataLoaded" v-if="user">
        <source :src="url" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </a>
    <div class="video_name">
      <div class="channel_icon">
        <img :src="tagClass[1]" alt="" />
      </div>
      <div class="title">
        <h4 v-text="title"></h4>
      </div>
      <div class="heart" @click="toggleLike">
        <img v-if="isLiked" :src="require('@/assets/images/heart_click.svg')" alt="" />
        <img v-if="!isLiked" :src="require('@/assets/images/heart.svg')" alt="" />
      </div>
    </div>
    <div class="sub_title">
      <div class="resource" v-text="subTitle"></div>
      <div :class="tagClass[0]" v-text="videoTag"></div>
    </div>
  </div>
</template>
<style>
.heart {
  cursor: pointer;
}

.video_item {
  width: calc(33.33% - 10px);
  margin: 5px;
  height: auto;
  border: 1px solid rgb(209, 209, 209);
  border-radius: 7px;
  position: relative;
}

video {
  width: 100%;
  border-radius: 6px 6px 0 0;
  background-color: #fff;
}

.video_name {
  display: flex;
  padding: 10px;
}

.title {
  margin: 0 10px;
}

.title h4 {
  text-align: left;
}

.sub_title {
  display: flex;
  justify-content: space-between;
  padding: 0 10px 10px;
}

.tag_1,
.tag_2,
.tag_3,
.tag_4,
.tag_5 {
  font-size: 12px;
  color: #fff;
  padding: 0 6px;
}

.tag_1 {
  background-color: #6bb2a4;
}

.tag_2 {
  background-color: #de6c6b;
}

.tag_3 {
    background-color: #F0CA30;
}

.tag_4 {
    background-color: #FFAE4A;
}

.tag_5 {
    background-color: #AEDCED;
}

.broken_cookie {
  display: inline-block;
  margin-bottom: 10px;
}

.overlay {
  position: absolute;
  /* This will position the mask relative to its parent (which we set to position:relative) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  /* This will make it black with 50% opacity */
  z-index: 10;
}

.popup_window {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  max-width: 500px;
  padding: 20px;
  background-color: #ffffff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  z-index: 12;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

button {
  padding: 5px 10px;
}

button:hover {
  opacity: 0.8;
}
</style>
<script>
// import videoSource from "@/assets/images/farm_video.mov";
import { mapState } from "vuex"; // 引入 mapState

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: true,
    },
    videoTag: {
      type: String,
      required: true,
    },
    recommended: {
      type: Boolean,
      required: true,
    },
    liked: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      // videoSource,
      showPopup: false,
      videoDuration: 0, // 用於存儲影片的總長時間
      isLiked: this.liked,
    };
  },
  computed: {
    baseUrl() {
      return process.env.VUE_APP_PUBLIC_STARIC_PATH;
    },
    ...mapState(["user"]),
    tagClass() {
      switch (this.videoTag) {
        case "Music & Rhythm":
          return ["tag_1", require("@/assets/images/music_icon.svg")];
        case "Shapes & Colors":
          return ["tag_2", require("@/assets/images/shape_icon.svg")];
        case "Alphabet & Numbers":
          return ["tag_3", require("@/assets/images/alphabet_icon.svg")];
        case "Animal Names":
          return ["tag_4", require("@/assets/images/animal_icon.svg")];
        case "Science Concepts":
          return ["tag_5", require("@/assets/images/science_icon.svg")];
        // 如果有更多的 videoTag，您可以在此添加更多的 case
        default:
          return ["tag_3", require("@/assets/images/music_icon.svg")]; // 默認的 class，您可以根據需要修改
      }
    },
  },
  watch: {
    // 監視 user.limitSec 的變化
    "user.remaining": function (newRemaining) {
      this.checkLimitAgainstVideoDuration(newRemaining);
      // this.$emit('update-limitSec', { id: this.id, limitSec: this.limitSec });
    },
  },
  methods: {
    handleMetadataLoaded() {
      // 使用 ref 屬性獲取 video 元素的引用，然後獲取 duration 屬性
      this.videoDuration = this.$refs.videoPlayer.duration;
    },
    checkLimitAgainstVideoDuration(limitSec) {
      if (limitSec <= this.videoDuration) {
        this.showPopup = true;
      } else {
        this.showPopup = false;
      }
    },
    toggleLike() {
      this.isLiked = !this.isLiked;
      this.$emit("update-liked", { id: this.id, liked: this.isLiked });
    },
    navigateToPlay() {
      this.$router.push("play/" + this.id);
    },
  },
  mounted() {
    // 在元件掛載完成後，進行一次檢查，以確保即使在影片元數據加載之前 limitSec 也已經小於 videoDuration
    if (this.user) {
      this.checkLimitAgainstVideoDuration(this.user.limitSec);
    }
  },
};
</script>